import { availableEntityTypes } from "../../../smartBuildings/otherEntities/utils";

let EntityUtils = {

    buildMultipartRequest(entityData) {
        if(entityData.image) {
            let formBox = new FormData();
            formBox.append('files', entityData.image);
            entityData.image = null;
            formBox.append('request', new Blob([JSON.stringify(entityData)], {type: "application/json"}));
            entityData = formBox;
        }
        return entityData;
    },

    addEntityTypesSpecificData(entityType, entityData) {
        let transformedEntityData = { ...entityData };
        switch (entityType) {
            case availableEntityTypes.building:
                if(entityData.hasCheckInConfiguration) {
                    transformedEntityData = {
                        ...transformedEntityData,
                        buildingCheckInConfiguration: {
                            domain: entityData.domain,
                            enableNotification: entityData.enableNotification,
                            autoCheckOutDelay: entityData.autoCheckOutDelay,
                            operationTimeStart: entityData.operationTimeStart,
                            operationTimeEnd: entityData.operationTimeEnd
                        }
                    };
                }
                break;
            default:
                break;
        }
        return transformedEntityData;
    },

    spreadEntityTypesSpecificData(entityType, entityData) {
        let transformedEntityData = { ...entityData };
        switch (entityType) {
            case availableEntityTypes.building:
                if(entityData.checkInConfiguration) {
                    transformedEntityData = {
                        ...transformedEntityData,
                        hasCheckInConfiguration: true,
                        domain: entityData.checkInConfiguration.domain,
                        enableNotification: entityData.checkInConfiguration.enableNotification,
                        autoCheckOutDelay: entityData.checkInConfiguration.autoCheckOutDelay,
                        operationTimeStart: entityData.checkInConfiguration.operationTimeStart,
                        operationTimeEnd: entityData.checkInConfiguration.operationTimeEnd
                    };
                    delete transformedEntityData.checkInConfiguration
                }
                break;
            default:
                break;
        }
        return transformedEntityData;
    }
};

export default EntityUtils;